function Figure() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A figure is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>A <code>&lt;figure&gt;</code> represents self-contained content, potentially with an optional <code>&lt;figcaption&gt;</code>. Non-text content, if present, must have alternative text.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the figure presents accessible content and, if appropriate, has a figcaption.</p>
    </blockquote>
  )
}

export default Figure